import { createStandardAction } from 'typesafe-actions';
export var localeConfigActions = {
  setLanguage: createStandardAction('LOCALE_CONF_SET_LANGUAGE')()
};